import errorReporter from '@app/errorReporter';
import {
  formatActionTaken,
  formatNonAgentStatus,
  formatPhoneNumber,
  featureEnabled,
} from 'utils';
import { parseLabelFromString } from 'contexts';
import template from './appointment_deny.html';
import { NA_TYPE_MAP } from '../../constants/index';

angular.module('bb.appointments').component('bbAppointmentCancel', {
  bindings: {},
  controller: AppointmentCancelCtrl,
  controllerAs: 'vm',
  template,
});

AppointmentCancelCtrl.$inject = [
  '$scope',
  '$resource',
  '$rootScope',
  '$routeParams',
  'loadContacts',
  '$q',
  'AppointmentBookService',
];

function AppointmentCancelCtrl(
  $scope,
  $resource,
  $rootScope,
  $routeParams,
  loadContacts,
  $q,
  AppointmentBookService,
) {
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.viewDashAppointment = $rootScope.viewDashAppointment;
  vm.openContactDrawer = $rootScope.openContactDrawer;

  vm.naTypeMap = NA_TYPE_MAP;

  const Appointment = $resource('/appointments/:appointmentId', {
    appointmentId: '@appointmentId',
  });
  const AppointmentConfig = $resource(
    '/listing/:listingId/appointments/config',
    { listingId: '@listingId' },
  );
  const Cancel = $resource('/appointments/send/:appointmentId/cancel', {
    appointmentId: '@appointmentId',
  });
  const AppointmentList = $resource('/listing/:listingId/appointments', {
    listingId: '@listingId',
  });

  vm.hasNonAgentNotificationFeature = featureEnabled(
    'nonAgentNotificationFeature',
  );

  vm.action = {
    tab: 'history',
    restrictions: 'weekly',
  };

  vm.options = {
    button_label: 'Send Cancellation',
    label: 'Cancel Information for',
    custom_message: 'REASON FOR CANCELLATION (optional)',
    custom_message_placeholder: 'Why was this showing cancelled?',
  };

  vm.details = {};

  vm.formatNonAgentStatus = formatNonAgentStatus;

  // Move me into utils later
  vm.formatNonAgentNotification = () => {
    const naNameMap = {
      'Pest Control': 'PEST CONTROL',
      Photographer: 'PHOTOGRAPHER',
    };
    let naName = naNameMap[vm.appointment.type] || 'HOME INSPECTOR/APPRAISER';
    if (!vm.appointment.coop.isNotAgent) {
      naName = 'CUSTOM AGENT';
    }
    return `(${naName} ${
      vm.appointment.coop.approvedNonAgent ? '' : 'NOT '
    }NOTIFIED)`;
  };

  vm.formatActionTaken = ({
    status,
    originalTime,
    actionTaken,
    isPending,
    nonAgentNotified,
    date,
    auditEntry,
  }) => {
    return formatActionTaken(
      {
        date,
        auditEntry,
        status,
        originalTime,
        actionTaken,
        isPending,
        nonAgentNotified,
      },
      vm.appointment.type,
      vm.appointment.coop,
      vm.mustCallContacts,
      vm.appointment.history,
    );
  };

  vm.formatPhoneNumber = formatPhoneNumber;

  const checkMustCall = () => {
    if (!vm.listingContacts) return;
    const allPhoneNumbers = [];
    Object.values(vm.listingContacts).forEach(contact => {
      if (contact.phone && Array.isArray(contact.phone)) {
        allPhoneNumbers.push(...contact.phone);
      }
    });
    const mustCallExists = allPhoneNumbers.some(num => num.mustCall);
    vm.mustCall = vm.mustCall || mustCallExists;
    vm.mustCallContacts = vm.mustCall;
  };

  $scope.$watch('vm.listingContacts', () => {
    checkMustCall();
  });

  Appointment.get({ appointmentId: $routeParams.appointmentId })
    .$promise.then(data => {
      vm.appointment = data.appointment;
      vm.listing = data.listing;
      vm.listingLink = `#/listing/${vm.listing.id}/view`;
      vm.mlsTypes = data.listing.org?.mlsTypes.length
        ? data.listing.org.mlsTypes
        : null;

      if (
        [
          'Home Inspection',
          'Appraisal',
          'Photographer',
          'Pest Control',
        ].includes(vm.appointment.type)
      ) {
        vm.options.header_label = 'DELIVER CANCELLATION';
      } else if (vm.appointment.cancelledBy === 'seller') {
        vm.options.header_label = 'DELIVER CANCELLATION';
        if (vm.appointment.notify.email) {
          vm.options.header_label += ' TO SHOWING AGENT';
        }
        vm.options.label = 'Cancel Information for Showing Agent';
      } else if (vm.appointment.cancelledBy === 'unable') {
        vm.options.header_label = 'DELIVER CANCELLATION TO SHOWING AGENT';
        vm.options.label = 'Cancel Information for Showing Agent';
      } else {
        vm.options.header_label = 'DELIVER CANCELLATION TO SELLER';
        vm.options.label = 'Cancel Information for Seller';
      }

      AppointmentConfig.get({ listingId: vm.listing.id })
        .$promise.then(appointmentConfig => {
          const agentIds = appointmentConfig.contacts
            .filter(contact => contact.type === 'Agent')
            .map(contact => contact.contactId);
          loadContacts($resource, vm, $q, vm.listing.id, agentIds).catch(
            errorReporter.error,
          );

          vm.appointmentConfig = appointmentConfig;

          vm.cancellation = {
            appointmentId: $routeParams.appointmentId,
            isPending: false,
            details: vm.details,
            notify: _.clone(data.appointment.notify),
          };

          if (
            featureEnabled('nonAgentNotificationFeature') &&
            vm.appointment.coop.nonAgentId &&
            !featureEnabled('customContactDashboardFeature')
          ) {
            vm.cancellation.notify = {
              text: false,
              email: Boolean(vm.appointment.coop.approvedNonAgent),
              office: !vm.appointment.coop.approvedNonAgent,
            };
            vm.cancellation.actionTaken = '';
          }
        })
        .catch(errorReporter.error)
        .finally(() => {
          vm.dataLoaded = true;
        });
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentTextDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.textDeliveryLog = data;
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentEmailDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.emailDeliveryLog = data;
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentPushNotificationDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.pushNotificationDeliveryLog = data;
    })
    .catch(errorReporter.error);

  vm.hasListingContact = contact =>
    Object.keys(vm.listingContacts || {}).includes(
      contact.id || contact.contactId,
    );

  vm.loadAppointments = () => {
    if (vm.appointmentsLoaded) return;

    AppointmentList.query({ listingId: vm.listing.id })
      .$promise.then(appointments => {
        vm.appointments = appointments;
        vm.appointmentsLoaded = true;
      })
      .catch(errorReporter.error);
  };

  vm.selectSpecialDay = day => {
    vm.restrictDate = day;
  };

  vm.submit = () => {
    vm.dataLoaded = false;
    if (!vm.cancellation.details) {
      vm.cancellation.details = {};
    }

    const { actionDetails } =
      vm.appointment.history[vm.appointment.history.length - 1];

    if (vm.cancellation.notify.office) {
      vm.cancellation.details.message = actionDetails
        ? actionDetails.message
        : null;
    } else {
      vm.cancellation.details.message =
        vm.cancellation.details.message || vm.details.message;
    }

    const cancel = new Cancel(vm.cancellation);
    cancel.$save(() => {
      $rootScope.viewNextAppointmentPage(
        $routeParams.appointmentId,
        false,
        'cancel',
        vm.listing.id,
      );
    });
  };

  $scope.$watch(
    'vm.cancellation',
    () => {
      const { cancellation } = vm;
      if (!cancellation) return;

      if (cancellation.isPending) {
        vm.options.button_label = 'Attempted';
      } else {
        if (cancellation.notify.email) {
          vm.options.button_label = 'Send Cancellation';
        }
        if (cancellation.notify.office) {
          vm.options.button_label = 'Delivered';
        }
      }
    },
    true,
  );

  $rootScope.$watch('labelOverrideMap', () => {
    vm.relabelListingAvailability = availability =>
      $rootScope.labelOverrideMap[parseLabelFromString(availability)]?.label ||
      availability;
  });
}
